<div id="content">
  <!-- Content Row -->
  <div class="row">
    <div class="col-xl-12">
      <div class="card shadow mb-4">
        <div class="card-body" style="font-weight: bold; text-align: center">
          Unauthorized Access
        </div>
      </div>
    </div>
  </div>
</div>
